// Angular
import { Platform } from '@angular/cdk/platform';
import { Component, OnInit, OnDestroy, ViewEncapsulation, Input, SimpleChanges, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
// RxJS
import { Observable, Subscription } from 'rxjs';
// Layout
// import { LayoutConfigService } from '../../../../../core/_base/layout';

@Component({
	selector: 'kt-customer-timeline',
	templateUrl: './customer-timeline.component.html',
	styleUrls: ['./customer-timeline.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class CustomerTimelineComponent implements OnInit, OnDestroy {
	selectedTab: number = 0;
	@Input() customerId: number;
	@Input() statusList: any;
	@Input() userName: any;
	@Input() referralList: any;
	@Input() referByCode: any;
	@Input() opportunityId: any;
	@Input() isCheckBox: any;
	@Input() opportunityName: any;
	@Input() opportunityNumber: any;
	@Output() close = new EventEmitter<void>();
	loading$: Observable<boolean>;
	routeId: number;
	isMobile: boolean = false;
	customerStatusList:any;
	private subscriptions: Subscription[] = [];

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		public platform: Platform,
		private el: ElementRef
		// private layoutConfigService: LayoutConfigService,
	) { }

	ngOnInit() {
		//read routeId parameter from route and set routeId if this page visited from roaster Plan page
		this.activatedRoute.paramMap.subscribe((params: ParamMap |any) => {
			this.routeId = parseInt(params.get('id'));
		});
		this.isMobile = this.platform.ANDROID || this.platform.IOS;
	}

	ngOnChanges(changes: SimpleChanges) {
		this.selectedTab = 0;
		this.routeId = this.customerId;
		this.customerStatusList = this.statusList;
	}
	closeTimeline() {
		this.close.emit();  // Notify parent to close the drawer
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sb => sb.unsubscribe());
	}

	/**
	 * Redirect to list
	 *
	 */
	goBackWithId() {
		// const url:any = `${this.layoutConfigService.getCurrentMainRoute()}/user-management/users`;
		// this.router.navigate(url, { relativeTo: this.activatedRoute }); // changed here that previous it was navigatebyurl

	}

}
